import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "hasStructuredFooter", "hasStep", "flush", "children"];
import styled from 'foundations-theming/utils';
import { toPx } from '../../../utils/toPx';
import { usePopoverContext } from './PopoverContext';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledPopoverFooter = styled.footer.withConfig({
  displayName: "PopoverFooter__StyledPopoverFooter",
  componentId: "sc-1cdlzdr-0"
})(({
  $flush,
  $hasStructuredFooter,
  $hasStep,
  $align,
  $cssStyles,
  theme
}) => {
  const use = usePopoverContext().use;
  return Object.assign({
    background: 'inherit',
    borderRadius: 'inherit',
    borderTopLeftRadius: theme.borderRadius['0'],
    borderTopRightRadius: theme.borderRadius['0'],
    paddingBlockStart: $flush ? theme.space['0'] : use === 'longform' ? theme.space['0'] : use === 'shepherd' ? $hasStructuredFooter ? toPx(parseInt(theme.space['600'], 10) - parseInt(theme.space['400'], 10)) : theme.space[0] : theme.space['500'],
    paddingInlineEnd: $flush ? theme.space['0'] : use === 'longform' ? theme.space['500'] : use === 'shepherd' ? theme.space['600'] : theme.space['600'],
    paddingBlockEnd: $flush ? theme.space['0'] : use === 'longform' ? theme.space['500'] : use === 'shepherd' ? $hasStructuredFooter ? theme.space['500'] : theme.space['400'] : theme.space['500'],
    paddingInlineStart: $flush ? theme.space['0'] : use === 'longform' ? theme.space['500'] : use === 'shepherd' ? theme.space['600'] : theme.space['600'],
    textAlign: $align
  }, $hasStep ? {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  } : undefined, $cssStyles);
});
export const PopoverFooter = _ref => {
  let {
      align = 'left',
      hasStructuredFooter = false,
      hasStep = false,
      flush = false,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledPopoverFooter, Object.assign({}, domProps, {
    $align: align,
    $hasStructuredFooter: hasStructuredFooter,
    $hasStep: hasStep,
    $flush: flush,
    $cssStyles: cssStyles,
    children: children
  }));
};